import React from 'react'


/**
 * Derive and interface
 */
import {pure} from '@react/store'
import {DefaultComponentProps} from '@interface/common'

/**
 * Modals
 */
import alert from '@components/modals/alert'
import view from '@components/modals/view'
import sending from '@components/modals/sending'
import addOrg from '@components/modals/organization/add'
import addAccount from '@components/modals/account/add'
import createPost from '@components/modals/post/create'
import accountDetail from '@components/modals/account/detail'
import sessionExpired from '@components/modals/sessionExpired'
import spaceControls from '@components/modals/controls/space'
import groupControls from '@components/modals/controls/group'


type ModalType = {
  [key: string]: React.FunctionComponent<any>
}

/**
 * List of Modals
 */
const List: ModalType = {
  view,
  alert,
  addOrg,
  sending,
  createPost,
  addAccount,
  spaceControls,
  groupControls,
  accountDetail,
  sessionExpired,
}

/**
 * Modal content
 */
export default pure(({store}: DefaultComponentProps) => {
  var modal = store.get('modal')

  if(typeof modal === 'string') {
    modal = {
      data: {name: modal}
    }
  }
  
  if(modal.data) {
    const data = modal.data

    var Content = List[data.name]
    if(Content) {
      return (
        <div
          className="modal"
          onClick={(e) => {
            modal.close()
          }}>
          <Content data={data.data}/>
        </div>
      )
    }
  }
  return null
})